"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.constructModifyInputValueOnSelectFn = void 0;
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _downshift = _interopRequireDefault(require("downshift"));
const constructModifyInputValueOnSelectFn = _ref => {
  let {
    multiSelect,
    disableAutoModifyText,
    clearTextOnSelect
  } = _ref;
  return _ref2 => {
    let {
      oldInputValue
    } = _ref2;
    if (multiSelect) return {
      inputValue: ''
    };
    if (clearTextOnSelect) return {
      inputValue: ''
    };
    if (disableAutoModifyText) return {
      inputValue: oldInputValue
    };
    return {};
  };
};
exports.constructModifyInputValueOnSelectFn = constructModifyInputValueOnSelectFn;
const constructModifiedStateReducer = _ref3 => {
  let {
    multiSelect,
    hideDropdownWhenInputIsEmpty,
    disableCloseOnSelect,
    modifyInputValueOnSelectFn
  } = _ref3;
  return (state, changes) => {
    var _context, _context5;
    let workingChanges = changes;
    if ((0, _includes.default)(_context = [_downshift.default.stateChangeTypes.blurInput,
    // user tabs out
    _downshift.default.stateChangeTypes.mouseUp // user clicks outside
    ]).call(_context, changes.type)) {
      // Upon losing focus, Downshift's default behavior is to set inputValue to null,
      // and remain null upon refocus - only becoming a string again once the user
      // modifies the inputValue. This default behavior would make it impossible to
      // immediately use the inputValue to filter the dropdown when the component is
      // used as an uncontrolled typeahead, so we override it, and keep inputValue as
      // its string value.
      workingChanges = {
        ...workingChanges,
        inputValue: state.inputValue
      };
    }
    if (multiSelect && changes.type === _downshift.default.stateChangeTypes.clickItem) {
      // Keep dropdown menu open upon selection when using multiSelect
      workingChanges = {
        ...workingChanges,
        inputValue: '',
        isOpen: true
      };
    }
    if (hideDropdownWhenInputIsEmpty) {
      var _context2, _context3;
      // As of Downshift 3.3.4, an `undefined` action is dispatched when the user clicks
      // on the component.
      const DownshiftStateChangeTypesOnClick = undefined;
      if ((0, _includes.default)(_context2 = [DownshiftStateChangeTypesOnClick, _downshift.default.stateChangeTypes.changeInput]).call(_context2, changes.type)) {
        workingChanges = {
          ...workingChanges,
          isOpen: !!changes.inputValue
        };
      }
      if ((0, _includes.default)(_context3 = [_downshift.default.stateChangeTypes.keyDownEnter, _downshift.default.stateChangeTypes.clickItem]).call(_context3, changes.type)) {
        workingChanges = {
          ...workingChanges,
          inputValue: multiSelect ? '' : changes.inputValue,
          isOpen: false
        };
      }
    }
    if (disableCloseOnSelect) {
      var _context4;
      if ((0, _includes.default)(_context4 = [_downshift.default.stateChangeTypes.keyDownEnter, _downshift.default.stateChangeTypes.clickItem]).call(_context4, changes.type)) {
        workingChanges = {
          ...workingChanges,
          isOpen: state.isOpen,
          highlightedIndex: state.highlightedIndex
        };
      }
    }
    if (modifyInputValueOnSelectFn != null && (0, _includes.default)(_context5 = [_downshift.default.stateChangeTypes.keyDownEnter, _downshift.default.stateChangeTypes.clickItem]).call(_context5, changes.type)) {
      workingChanges = {
        ...workingChanges,
        ...modifyInputValueOnSelectFn({
          oldInputValue: state.inputValue
        })
      };
    }
    return workingChanges;
  };
};
var _default = exports.default = constructModifiedStateReducer;